/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import {
  ElectricalSettingsInformation,
  ElectricalSettingsObjectInformation,
} from '../../../../../feature/src/lib/models/electrical-settings-information';
import { ElectricalSettingsStatusResult } from '../../../../../feature/src/lib/models/electrical-settings-return';
import { ElectricalSettingsObject } from '../../../../../feature/src/lib/models/electrical-settings-shortcuts';
import { SysqueElectricalState } from '../../../../../feature/src/lib/models/sysque-electrical-state';
import { Observable } from 'rxjs';

export interface IElectricalSettingsFacade {
  closeWindow(): void;
  getElectricalSystemsInformation(): Observable<ElectricalSettingsObjectInformation>;
  getElectricalShortcutsModifiersInformation(): Observable<ElectricalSettingsObject>;
  getInvalidShortcuts(
    electricalSettingsChanges: ElectricalSettingsInformation
  ): Observable<ElectricalSettingsStatusResult>;
  applyPreferences(electricalSettingsChanges: ElectricalSettingsInformation): void;
  updateLocalStorage(key: string, value: any): void;
  onWindowResize(height: number): void
  getState(): SysqueElectricalState;
}

export const ELECTRICAL_SETTINGS_FACADE_TOKEN = new InjectionToken<IElectricalSettingsFacade>(
  'ELECTRICAL_SETTINGS_FACADE_TOKEN'
);
